import {ProductLine} from './product-line.enum';
import {TemplateDefinition} from './template-definition';

export class Template {

  constructor(
    public name: string,
    public displayLabel?: string,
    public productLine?: ProductLine,
    public definitions?: Array<TemplateDefinition>
  ) {
    this.definitions = [];
  }

}
